module.exports = __webpack_public_path__ + "img/lazy-placeholder.f977b520.png";